export default "__VITE_ASSET__C8d5kHE6__"